module.exports = __webpack_public_path__ + "static/media/Lose1.de510273.wav";